webpackJsonp([46],{

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BigDataView_vue__ = __webpack_require__(2544);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb86672_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BigDataView_vue__ = __webpack_require__(3298);
function injectStyle (ssrContext) {
  __webpack_require__(3296)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fb86672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BigDataView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb86672_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BigDataView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeIndex_vue__ = __webpack_require__(2708);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd405ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeIndex_vue__ = __webpack_require__(4125);
function injectStyle (ssrContext) {
  __webpack_require__(4119)
  __webpack_require__(4121)
  this["$style"] = __webpack_require__(4123)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fd405ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd405ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(54).f;
var create = __webpack_require__(240);
var redefineAll = __webpack_require__(247);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(246);
var forOf = __webpack_require__(239);
var $iterDefine = __webpack_require__(150);
var step = __webpack_require__(251);
var setSpecies = __webpack_require__(252);
var DESCRIPTORS = __webpack_require__(40);
var fastKey = __webpack_require__(1353).fastKey;
var validate = __webpack_require__(1387);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(28);
var meta = __webpack_require__(1353);
var fails = __webpack_require__(76);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(247);
var forOf = __webpack_require__(239);
var anInstance = __webpack_require__(246);
var isObject = __webpack_require__(55);
var setToStringTag = __webpack_require__(105);
var dP = __webpack_require__(54).f;
var each = __webpack_require__(1422)(0);
var DESCRIPTORS = __webpack_require__(40);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(149);
var toObject = __webpack_require__(78);
var toLength = __webpack_require__(106);
var asc = __webpack_require__(1423);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1424);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
var isArray = __webpack_require__(1356);
var SPECIES = __webpack_require__(22)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(146);
var from = __webpack_require__(1426);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(239);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);
var aFunction = __webpack_require__(80);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(239);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1450), __esModule: true };

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(241);
__webpack_require__(143);
__webpack_require__(234);
__webpack_require__(1451);
__webpack_require__(1452);
__webpack_require__(1453);
__webpack_require__(1454);
module.exports = __webpack_require__(12).Set;


/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1420);
var validate = __webpack_require__(1387);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1421)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(28);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1425)('Set') });


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1427)('Set');


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1428)('Set');


/***/ }),

/***/ 2544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BigDataView',
  data: function data() {
    return {
      currentDateTime: '',
      provinceFilter: '',
      cityFilter: '',
      projectFilter: '',
      selectedProvince: '',
      selectedCity: '',
      selectedProject: '',
      canViewAllData: false,
      showPersonalPanel: false, // 是否显示个人面板
      provinceOptions: [], // 省份选项列表
      cityOptions: [], // 城市选项列表（当前选中的省份下的城市）
      allCityOptions: [], // 所有城市选项列表（用于联动）
      projectOptions: [], // 项目选项列表
      provinceCityMap: {}, // 省份-城市映射
      allTableData: [], // 保存所有原始数据，用于本地筛选
      statistics: {
        projectCount: 0,
        cityCount: 0,
        positiveDeviationCount: 0,
        negativeDeviationCount: 0
      },
      tableData: [],
      sortConfig: {},
      tableHeight: 600,
      projectSpanArr: [], // 存储项目列的合并信息
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    }
  })),
  watch: {
    tableData: {
      handler: function handler() {
        this.getProjectSpanArr();
      },

      immediate: true
    },
    provinceFilter: function provinceFilter(newVal) {
      // 省份变化时，清空城市选择，更新城市选项
      if (newVal !== this.selectedProvince) {
        this.cityFilter = '';
        this.updateCityOptions(newVal);
      }
    }
  },
  mounted: function mounted() {
    this.updateDateTime();
    // // 每秒更新一次时间
    // setInterval(() => {
    //   this.updateDateTime()
    // }, 1000)
    // 计算表格高度
    this.calculateTableHeight();
    // 监听窗口大小变化
    window.addEventListener('resize', this.calculateTableHeight);
    // 加载数据
    this.loadData();
  },
  beforeDestroy: function beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.calculateTableHeight);
  },

  methods: {
    /**
     * 计算项目列的合并信息
     */
    getProjectSpanArr: function getProjectSpanArr() {
      this.projectSpanArr = [];
      if (this.tableData.length === 0) {
        return;
      }

      // 初始化数组，每个元素代表该行的rowspan，默认为0
      this.projectSpanArr = new Array(this.tableData.length).fill(0);

      // 遍历表格数据，找到每个项目组的起始位置和行数
      var currentProject = null;
      var startIndex = 0;

      for (var i = 0; i < this.tableData.length; i++) {
        var project = this.tableData[i].project;

        if (currentProject === null) {
          // 第一个项目
          currentProject = project;
          startIndex = i;
        } else if (project !== currentProject) {
          // 遇到新项目，计算上一个项目组的行数
          var rowspan = i - startIndex;
          this.projectSpanArr[startIndex] = rowspan;
          // 开始新的项目组
          currentProject = project;
          startIndex = i;
        }
      }

      // 处理最后一个项目组
      if (currentProject !== null) {
        var _rowspan = this.tableData.length - startIndex;
        this.projectSpanArr[startIndex] = _rowspan;
      }
    },

    /**
     * 单元格合并方法
     * @param {Object} param - { row, column, rowIndex, columnIndex }
     * @returns {Object} - { rowspan, colspan }
     */
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      // 只合并第一列（项目列）
      if (columnIndex === 0) {
        var rowspan = this.projectSpanArr[rowIndex];
        var colspan = rowspan > 0 ? 1 : 0;
        return {
          rowspan: rowspan,
          colspan: colspan
        };
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    calculateTableHeight: function calculateTableHeight() {
      // 计算表格高度：视口高度 - 头部 - 筛选统计区域 - 表格标题和padding
      var headerHeight = 60;
      var filterStatsHeight = 180;
      var tableSectionPadding = 80;
      this.tableHeight = window.innerHeight - headerHeight - filterStatsHeight - tableSectionPadding;
    },
    updateDateTime: function updateDateTime() {
      this.currentDateTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:00:00');
    },

    /**
     * 获取当前登录用户ID
     */
    getCurrentUserId: function getCurrentUserId() {
      return this.user.id * 1;
    },

    /**
     * 筛选按钮点击事件
     */
    handleFilter: function handleFilter() {
      this.selectedProvince = this.provinceFilter || '';
      this.selectedCity = this.cityFilter || '';
      this.selectedProject = this.projectFilter || '';
      // 本地筛选数据
      this.filterLocalData();
    },

    /**
     * 个人面板开关变化事件
     */
    handlePersonalPanelChange: function handlePersonalPanelChange(value) {
      var _this = this;

      // 显示loading
      var loading = this.$loading({
        lock: true,
        text: '数据处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 延迟执行筛选,让loading有足够时间显示
      setTimeout(function () {
        // 重新筛选数据
        _this.filterLocalData();
        // 关闭loading
        loading.close();
      }, 300);
    },

    /**
     * 本地筛选数据
     */
    filterLocalData: function filterLocalData() {
      var _this2 = this;

      var filteredData = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.allTableData));

      // 个人面板：只显示当前登录用户的数据
      if (this.showPersonalPanel) {
        var currentUserId = this.getCurrentUserId();
        filteredData = filteredData.filter(function (item) {
          return item._raw && item._raw.member_adminid * 1 === currentUserId;
        });
      }

      // 根据省份筛选
      if (this.provinceFilter) {
        filteredData = filteredData.filter(function (item) {
          return item._raw && item._raw.province_name === _this2.provinceFilter;
        });
      }

      // 根据城市筛选
      if (this.cityFilter) {
        filteredData = filteredData.filter(function (item) {
          return item._raw && item._raw.city_name === _this2.cityFilter;
        });
      }

      // 根据项目筛选
      if (this.projectFilter) {
        filteredData = filteredData.filter(function (item) {
          return item._raw && item._raw.project_name === _this2.projectFilter;
        });
      }

      this.tableData = filteredData;
      // 重新计算统计数据（基于筛选后的数据）
      this.calculateStatisticsFromTableData();
    },

    /**
     * 加载数据（只在页面刷新时调用）
     */
    loadData: function loadData() {
      var _this3 = this;

      this.loading = true;
      // 不传省份参数，获取所有数据
      request.page('getBigDataResult', { adminid: this.getCurrentUserId() }).then(function (_ref2) {
        var data = _ref2.data;

        _this3.canViewAllData = _.get(data, 'view_national_data', false);
        if (Array.isArray(data.data) && data.data.length > 0) {
          // 转换数据格式
          _this3.allTableData = _this3.transformTableData(data.data);
          // 提取省份选项
          _this3.extractProvinceOptions(data.data);
          // 提取城市选项
          _this3.extractCityOptions(data.data);
          // 提取项目选项
          _this3.extractProjectOptions(data.data);
          // 默认显示全部数据
          _this3.tableData = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this3.allTableData));
          // 计算统计数据（全部数据）
          _this3.calculateStatisticsFromTableData();
          // 更新当前时间
          _this3.updateDateTime();
        } else {
          _this3.allTableData = [];
          _this3.tableData = [];
          _this3.provinceOptions = [];
          _this3.cityOptions = [];
          _this3.allCityOptions = [];
          _this3.provinceCityMap = {};
          _this3.projectOptions = [];
          _this3.statistics = {
            projectCount: 0,
            cityCount: 0,
            positiveDeviationCount: 0,
            negativeDeviationCount: 0
          };
        }
      }).catch(function (error) {
        console.error('加载数据失败:', error);
        _this3.$message.error('加载数据失败，请稍后重试');
      }).finally(function () {
        _this3.loading = false;
      });
    },

    /**
     * 提取省份选项
     */
    extractProvinceOptions: function extractProvinceOptions(detail) {
      var provinceSet = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (detail && Array.isArray(detail)) {
        detail.forEach(function (item) {
          if (item.province_name) {
            provinceSet.add(item.province_name);
          }
        });
      }
      // 转换为选项数组
      this.provinceOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(provinceSet).map(function (name) {
        return {
          label: name,
          value: name
        };
      }).sort(function (a, b) {
        return a.label.localeCompare(b.label);
      }); // 按名称排序
    },

    /**
     * 提取城市选项并构建省份-城市映射
     */
    extractCityOptions: function extractCityOptions(detail) {
      var _this4 = this;

      this.provinceCityMap = {};
      var allCitySet = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();

      if (detail && Array.isArray(detail)) {
        detail.forEach(function (item) {
          var provinceName = item.province_name;
          var cityName = item.city_name;

          if (provinceName && cityName) {
            // 构建省份-城市映射
            if (!_this4.provinceCityMap[provinceName]) {
              _this4.provinceCityMap[provinceName] = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
            }
            _this4.provinceCityMap[provinceName].add(cityName);

            // 收集所有城市
            allCitySet.add(cityName);
          }
        });
      }

      // 转换所有城市选项数组（初始显示所有城市）
      this.allCityOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(allCitySet).map(function (name) {
        return {
          label: name,
          value: name
        };
      }).sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });

      // 初始城市选项显示所有
      this.cityOptions = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.allCityOptions));
    },

    /**
     * 根据选中的省份更新城市选项
     */
    updateCityOptions: function updateCityOptions(province) {
      if (!province) {
        // 如果没有选择省份，显示所有城市
        this.cityOptions = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.allCityOptions));
      } else {
        // 根据选中的省份筛选城市
        var cities = this.provinceCityMap[province];
        if (cities) {
          this.cityOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(cities).map(function (name) {
            return {
              label: name,
              value: name
            };
          }).sort(function (a, b) {
            return a.label.localeCompare(b.label);
          });
        } else {
          this.cityOptions = [];
        }
      }
    },

    /**
     * 提取项目选项
     */
    extractProjectOptions: function extractProjectOptions(detail) {
      var projectSet = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (detail && Array.isArray(detail)) {
        detail.forEach(function (item) {
          if (item.project_name) {
            projectSet.add(item.project_name);
          }
        });
      }
      // 转换为选项数组
      this.projectOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(projectSet).map(function (name) {
        return {
          label: name,
          value: name
        };
      }).sort(function (a, b) {
        return a.label.localeCompare(b.label);
      }); // 按名称排序
    },

    /**
     * 转换表格数据格式
     */
    transformTableData: function transformTableData(detail) {
      if (!detail || !Array.isArray(detail)) {
        return [];
      }

      return detail.map(function (item) {
        // 将接口字段映射到表格字段
        return {
          project: item.project_name || '',
          province: item.province_name || '',
          city: item.city_name || '', // 保留城市字段，可能用于其他用途
          manager: item.member_name || '', // 负责人
          targetQuantity: parseInt(item.target_order_count) || 0,
          yesterdayCompleted: parseInt(item.yesterday_complete_count) || 0,
          currentCompleted: parseInt(item.current_complete_count) || 0,
          growth: parseInt(item.growth_count) || 0,
          completionRate: parseFloat(item.current_complete_ratio) || 0,
          progressDeviation: parseInt(item.schedule_variance) || 0,
          activeUsers: parseInt(item.active_user_count) || 0,
          standbyUsers: parseInt(item.inactive_user_count) || 0,
          participatingUsers: parseInt(item.involved_user_count) || 0,
          // 保留原始数据，用于筛选等操作
          _raw: item
        };
      });
    },

    /**
     * 根据表格数据计算统计数据（用于本地筛选后的统计）
     */
    calculateStatisticsFromTableData: function calculateStatisticsFromTableData() {
      if (!this.tableData || this.tableData.length === 0) {
        this.statistics = {
          projectCount: 0,
          cityCount: 0,
          positiveDeviationCount: 0,
          negativeDeviationCount: 0
        };
        return;
      }

      // 获取所有唯一的项目
      var projects = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      // 获取所有唯一的城市
      var cities = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      // 统计进度偏差正值和负值的城市数
      var positiveCities = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      var negativeCities = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();

      this.tableData.forEach(function (item) {
        if (item.project) {
          projects.add(item.project);
        }
        if (item.city) {
          cities.add(item.city);
          // 判断进度偏差值的正负
          var variance = item.progressDeviation || 0;
          if (variance > 0) {
            positiveCities.add(item.city);
          } else if (variance < 0) {
            negativeCities.add(item.city);
          }
        }
      });

      this.statistics = {
        projectCount: projects.size,
        cityCount: cities.size,
        positiveDeviationCount: positiveCities.size,
        negativeDeviationCount: negativeCities.size
      };
    },
    handleLogout: function handleLogout() {
      var _this5 = this;

      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 这里可以添加退出登录逻辑
        _this5.$message.success('退出登录成功');
        // this.$store.commit('LOGOUT')
        // this.$router.push('/login')
      }).catch(function () {});
    },
    handleSortChange: function handleSortChange(_ref3) {
      var column = _ref3.column,
          prop = _ref3.prop,
          order = _ref3.order;

      // 处理排序
      if (order) {
        this.sortConfig = { prop: prop, order: order };
        this.sortTableData(prop, order);
      } else {
        this.sortConfig = {};
        // 恢复原始数据顺序 - 重新加载数据
        this.resetTableData();
      }
    },
    sortTableData: function sortTableData(prop, order) {
      // 为了保持项目合并功能，需要先按项目分组，然后在项目组内排序
      var data = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.tableData));

      // 如果排序的列就是项目列，直接排序
      if (prop === 'project') {
        data.sort(function (a, b) {
          if (order === 'ascending') {
            return a.project.localeCompare(b.project);
          } else {
            return b.project.localeCompare(a.project);
          }
        });
      } else {
        // 其他列排序：先按项目分组，然后在项目组内按指定列排序
        // 1. 先按项目分组
        var projectGroups = {};
        data.forEach(function (item) {
          if (!projectGroups[item.project]) {
            projectGroups[item.project] = [];
          }
          projectGroups[item.project].push(item);
        });

        // 2. 在每个项目组内排序
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(projectGroups).forEach(function (projectName) {
          projectGroups[projectName].sort(function (a, b) {
            var aVal = a[prop];
            var bVal = b[prop];

            // 如果是进度偏差值，需要处理正负值
            if (prop === 'progressDeviation') {
              aVal = a.progressDeviation;
              bVal = b.progressDeviation;
            }

            if (order === 'ascending') {
              return aVal - bVal;
            } else {
              return bVal - aVal;
            }
          });
        });

        // 3. 按项目名称排序项目组（保持项目的原始顺序，或者可以按字母序）
        var projectOrder = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(data.map(function (item) {
          return item.project;
        })));
        var sortedData = [];
        projectOrder.forEach(function (projectName) {
          sortedData.push.apply(sortedData, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(projectGroups[projectName]));
        });

        this.tableData = sortedData;
        return;
      }

      this.tableData = data;
    },
    resetTableData: function resetTableData() {
      // 重新加载数据
      this.loadData();
    }
  }
});

/***/ }),

/***/ 2708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {},
  filters: {}
});

/***/ }),

/***/ 3296:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3297);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("089ee803", content, true, {});

/***/ }),

/***/ 3297:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".big-data-view[data-v-0fb86672]{height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#f0f2f5;padding:0;overflow:hidden}.big-data-view[data-v-0fb86672],.header-section[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box}.header-section[data-v-0fb86672]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:15px 30px;background-color:#fff;border-bottom:1px solid #e8e8e8;height:60px;-ms-flex-negative:0;flex-shrink:0}.header-section .header-left[data-v-0fb86672]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.header-section .header-left .datetime[data-v-0fb86672]{font-size:14px;color:#606266;font-weight:500}.header-section .header-center[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center}.header-section .header-center .system-title[data-v-0fb86672]{font-size:22px;font-weight:700;color:#303133;margin:0;letter-spacing:1px}.header-section .header-right[data-v-0fb86672]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;text-align:right}.header-section .header-right .logout-btn[data-v-0fb86672]{font-size:20px;color:#606266;padding:5px;border:none;background:transparent;cursor:pointer}.header-section .header-right .logout-btn[data-v-0fb86672]:hover{color:#409eff}.filter-stats-section[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;padding:20px 0;background-color:#f0f2f5;-ms-flex-negative:0;flex-shrink:0}.filter-section[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:15px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;padding:25px 30px;border-radius:4px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 3px rgba(0,0,0,.1)}.filter-section .filter-form[data-v-0fb86672]{width:100%}.filter-section .filter-form ::v-deep .el-form-item[data-v-0fb86672]{margin-bottom:0}.filter-section .filter-form ::v-deep .el-form-item__label[data-v-0fb86672]{font-weight:500;color:#606266}.filter-section .filter-form .filter-input[data-v-0fb86672]{width:200px}.filter-section .filter-form .filter-btn[data-v-0fb86672]{padding:9px 30px;min-width:100px}.filter-section .filter-form ::v-deep .el-switch .el-switch__label[data-v-0fb86672]{font-size:14px;font-weight:500;color:#606266}.filter-section .filter-button-row[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.filter-section .selected-province[data-v-0fb86672]{font-size:20px;font-weight:700;color:#303133}.stats-section[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;background-color:#fff;padding:25px 30px;border-radius:4px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 3px rgba(0,0,0,.1)}.stats-section .stats-title[data-v-0fb86672]{font-size:16px;font-weight:700;color:#303133;margin-bottom:25px}.stats-section .stats-grid[data-v-0fb86672]{display:grid;grid-template-columns:repeat(4,1fr);gap:15px}.stats-section .stats-grid .stat-item[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:15px;padding:10px}.stats-section .stats-grid .stat-item .stat-label[data-v-0fb86672]{font-size:14px;color:#909399;line-height:1.5}.stats-section .stats-grid .stat-item .stat-value[data-v-0fb86672]{font-size:28px;font-weight:700;color:#303133;line-height:1.2}.stats-section .stats-grid .stat-item .stat-value.positive[data-v-0fb86672]{color:#67c23a}.stats-section .stats-grid .stat-item .stat-value.negative[data-v-0fb86672]{color:#f56c6c}.table-section[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;background-color:#fff;padding:20px;border-radius:4px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 3px rgba(0,0,0,.1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-height:0;overflow:hidden}.table-section .table-title[data-v-0fb86672]{font-size:18px;font-weight:700;color:#303133;margin-bottom:15px;padding-bottom:10px;border-bottom:2px solid #e8e8e8}.table-section ::v-deep .el-table[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1}.table-section ::v-deep .el-table .el-table__body-wrapper[data-v-0fb86672]{overflow-y:auto}.table-section ::v-deep .el-table th[data-v-0fb86672]{background-color:#f5f7fa!important;color:#606266!important;font-weight:600!important;padding:12px 0;text-align:center}.table-section ::v-deep .el-table td[data-v-0fb86672]{padding:12px 0;text-align:center}.table-section ::v-deep .el-table .el-table__row[data-v-0fb86672]:hover{background-color:#f5f7fa}.table-section ::v-deep .el-table .el-table__fixed-right[data-v-0fb86672]{height:100%!important}.table-section .deviation-value[data-v-0fb86672]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:4px;font-weight:700;font-size:14px}.table-section .deviation-value.deviation-positive[data-v-0fb86672]{color:#67c23a}.table-section .deviation-value.deviation-negative[data-v-0fb86672]{color:#f56c6c}.table-section .deviation-value i[data-v-0fb86672]{font-size:16px;font-weight:700}", "", {"version":3,"sources":["/workspace/src/views/big-data-view/pages/BigDataView.vue"],"names":[],"mappings":"AACA,gCAAgC,YAAY,AAAqD,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,UAAU,AAAoD,eAAe,CAC/S,AACD,iEAF4C,oBAAoB,oBAAoB,aAAa,AAA4I,8BAA8B,qBAAsB,CAGhS,AADD,iCAAsF,yBAAyB,sBAAsB,8BAA8B,yBAAyB,sBAAsB,mBAAmB,kBAAkB,sBAAsB,gCAAgC,YAAY,AAAoD,oBAAoB,aAAa,CAC7Y,AACD,8CAA8C,mBAAmB,kBAAkB,aAAa,CAC/F,AACD,wDAAwD,eAAe,cAAc,eAAe,CACnG,AACD,gDAAgD,mBAAmB,WAAW,OAAO,iBAAiB,CACrG,AACD,8DAA8D,eAAe,gBAAiB,cAAc,SAAS,kBAAkB,CACtI,AACD,+CAA+C,mBAAmB,kBAAkB,cAAc,gBAAgB,CACjH,AACD,2DAA2D,eAAe,cAAc,YAAY,YAAY,uBAAuB,cAAc,CACpJ,AACD,iEAAiE,aAAa,CAC7E,AACD,uCAAuC,oBAAoB,oBAAoB,aAAa,SAAS,eAAe,yBAAyB,oBAAoB,aAAa,CAC7K,AACD,iCAAiC,mBAAmB,WAAW,OAAO,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,SAAS,yBAAyB,sBAAsB,mBAAmB,sBAAsB,kBAAkB,kBAAkB,4CAA6C,mCAAoC,CACzb,AACD,8CAA8C,UAAU,CACvD,AACD,qEAAqE,eAAe,CACnF,AACD,4EAA4E,gBAAgB,aAAa,CACxG,AACD,4DAA4D,WAAW,CACtE,AACD,0DAA0D,iBAAiB,eAAe,CACzF,AACD,oFAAoF,eAAe,gBAAgB,aAAa,CAC/H,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CAC3K,AACD,oDAAoD,eAAe,gBAAiB,aAAa,CAChG,AACD,gCAAgC,mBAAmB,WAAW,OAAO,sBAAsB,kBAAkB,kBAAkB,4CAA6C,mCAAoC,CAC/M,AACD,6CAA6C,eAAe,gBAAiB,cAAc,kBAAkB,CAC5G,AACD,4CAA4C,aAAa,oCAAqC,QAAQ,CACrG,AACD,uDAAuD,oBAAoB,oBAAoB,aAAa,8BAA8B,6BAA6B,uBAAuB,mBAAmB,yBAAyB,sBAAsB,mBAAmB,SAAS,YAAY,CACvS,AACD,mEAAmE,eAAe,cAAc,eAAe,CAC9G,AACD,mEAAmE,eAAe,gBAAiB,cAAc,eAAe,CAC/H,AACD,4EAA4E,aAAa,CACxF,AACD,4EAA4E,aAAa,CACxF,AACD,gCAAgC,mBAAmB,WAAW,OAAO,sBAAsB,aAAa,kBAAkB,4CAA6C,oCAAqC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,aAAa,eAAe,CACrY,AACD,6CAA6C,eAAe,gBAAiB,cAAc,mBAAmB,oBAAoB,+BAA+B,CAChK,AACD,mDAAmD,mBAAmB,WAAW,MAAM,CACtF,AACD,2EAA2E,eAAe,CACzF,AACD,sDAAsD,mCAAoC,wBAAyB,0BAA2B,eAAe,iBAAiB,CAC7K,AACD,sDAAsD,eAAe,iBAAiB,CACrF,AACD,wEAAwE,wBAAwB,CAC/F,AACD,0EAA0E,qBAAsB,CAC/F,AACD,iDAAiD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,QAAQ,gBAAiB,cAAc,CACnO,AACD,oEAAoE,aAAa,CAChF,AACD,oEAAoE,aAAa,CAChF,AACD,mDAAmD,eAAe,eAAgB,CACjF","file":"BigDataView.vue","sourcesContent":["\n.big-data-view[data-v-0fb86672]{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#f0f2f5;padding:0;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden\n}\n.header-section[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:15px 30px;background-color:#fff;border-bottom:1px solid #e8e8e8;height:60px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0\n}\n.header-section .header-left[data-v-0fb86672]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto\n}\n.header-section .header-left .datetime[data-v-0fb86672]{font-size:14px;color:#606266;font-weight:500\n}\n.header-section .header-center[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center\n}\n.header-section .header-center .system-title[data-v-0fb86672]{font-size:22px;font-weight:bold;color:#303133;margin:0;letter-spacing:1px\n}\n.header-section .header-right[data-v-0fb86672]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;text-align:right\n}\n.header-section .header-right .logout-btn[data-v-0fb86672]{font-size:20px;color:#606266;padding:5px;border:none;background:transparent;cursor:pointer\n}\n.header-section .header-right .logout-btn[data-v-0fb86672]:hover{color:#409eff\n}\n.filter-stats-section[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;padding:20px 0;background-color:#f0f2f5;-ms-flex-negative:0;flex-shrink:0\n}\n.filter-section[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:15px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;padding:25px 30px;border-radius:4px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.1);box-shadow:0 1px 3px rgba(0,0,0,0.1)\n}\n.filter-section .filter-form[data-v-0fb86672]{width:100%\n}\n.filter-section .filter-form ::v-deep .el-form-item[data-v-0fb86672]{margin-bottom:0\n}\n.filter-section .filter-form ::v-deep .el-form-item__label[data-v-0fb86672]{font-weight:500;color:#606266\n}\n.filter-section .filter-form .filter-input[data-v-0fb86672]{width:200px\n}\n.filter-section .filter-form .filter-btn[data-v-0fb86672]{padding:9px 30px;min-width:100px\n}\n.filter-section .filter-form ::v-deep .el-switch .el-switch__label[data-v-0fb86672]{font-size:14px;font-weight:500;color:#606266\n}\n.filter-section .filter-button-row[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.filter-section .selected-province[data-v-0fb86672]{font-size:20px;font-weight:bold;color:#303133\n}\n.stats-section[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;background-color:#fff;padding:25px 30px;border-radius:4px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.1);box-shadow:0 1px 3px rgba(0,0,0,0.1)\n}\n.stats-section .stats-title[data-v-0fb86672]{font-size:16px;font-weight:bold;color:#303133;margin-bottom:25px\n}\n.stats-section .stats-grid[data-v-0fb86672]{display:grid;grid-template-columns:repeat(4, 1fr);gap:15px\n}\n.stats-section .stats-grid .stat-item[data-v-0fb86672]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:15px;padding:10px\n}\n.stats-section .stats-grid .stat-item .stat-label[data-v-0fb86672]{font-size:14px;color:#909399;line-height:1.5\n}\n.stats-section .stats-grid .stat-item .stat-value[data-v-0fb86672]{font-size:28px;font-weight:bold;color:#303133;line-height:1.2\n}\n.stats-section .stats-grid .stat-item .stat-value.positive[data-v-0fb86672]{color:#67c23a\n}\n.stats-section .stats-grid .stat-item .stat-value.negative[data-v-0fb86672]{color:#f56c6c\n}\n.table-section[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1;background-color:#fff;padding:20px;border-radius:4px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.1);box-shadow:0 1px 3px rgba(0,0,0,0.1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-height:0;overflow:hidden\n}\n.table-section .table-title[data-v-0fb86672]{font-size:18px;font-weight:bold;color:#303133;margin-bottom:15px;padding-bottom:10px;border-bottom:2px solid #e8e8e8\n}\n.table-section ::v-deep .el-table[data-v-0fb86672]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.table-section ::v-deep .el-table .el-table__body-wrapper[data-v-0fb86672]{overflow-y:auto\n}\n.table-section ::v-deep .el-table th[data-v-0fb86672]{background-color:#f5f7fa !important;color:#606266 !important;font-weight:600 !important;padding:12px 0;text-align:center\n}\n.table-section ::v-deep .el-table td[data-v-0fb86672]{padding:12px 0;text-align:center\n}\n.table-section ::v-deep .el-table .el-table__row[data-v-0fb86672]:hover{background-color:#f5f7fa\n}\n.table-section ::v-deep .el-table .el-table__fixed-right[data-v-0fb86672]{height:100% !important\n}\n.table-section .deviation-value[data-v-0fb86672]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:4px;font-weight:bold;font-size:14px\n}\n.table-section .deviation-value.deviation-positive[data-v-0fb86672]{color:#67c23a\n}\n.table-section .deviation-value.deviation-negative[data-v-0fb86672]{color:#f56c6c\n}\n.table-section .deviation-value i[data-v-0fb86672]{font-size:16px;font-weight:bold\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-data-view"},[_c('div',{staticClass:"header-section"},[_c('div',{staticClass:"header-left"},[_c('span',{staticClass:"datetime"},[_vm._v("更新时间："+_vm._s(_vm.currentDateTime))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"header-left",staticStyle:{"opacity":"0"}},[_c('span',{staticClass:"datetime"},[_vm._v("更新时间："+_vm._s(_vm.currentDateTime))])])]),_vm._v(" "),_c('div',{staticClass:"filter-stats-section"},[_c('div',{staticClass:"filter-section"},[_c('el-form',{staticClass:"filter-form",attrs:{"inline":true,"size":"small"}},[_c('el-form-item',{attrs:{"label":"省份"}},[_c('el-select',{staticClass:"filter-input",attrs:{"placeholder":"请选择省份","clearable":""},model:{value:(_vm.provinceFilter),callback:function ($$v) {_vm.provinceFilter=$$v},expression:"provinceFilter"}},_vm._l((_vm.provinceOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"城市"}},[_c('el-select',{staticClass:"filter-input",attrs:{"placeholder":"请选择城市","clearable":"","filterable":""},model:{value:(_vm.cityFilter),callback:function ($$v) {_vm.cityFilter=$$v},expression:"cityFilter"}},_vm._l((_vm.cityOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目"}},[_c('el-select',{staticClass:"filter-input",attrs:{"placeholder":"请选择项目","clearable":"","filterable":""},model:{value:(_vm.projectFilter),callback:function ($$v) {_vm.projectFilter=$$v},expression:"projectFilter"}},_vm._l((_vm.projectOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.canViewAllData)?_c('el-form-item',[_c('el-switch',{attrs:{"active-text":"查看个人数据","inactive-text":"查看全国数据"},on:{"change":_vm.handlePersonalPanelChange},model:{value:(_vm.showPersonalPanel),callback:function ($$v) {_vm.showPersonalPanel=$$v},expression:"showPersonalPanel"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"filter-button-row"},[_c('el-button',{staticClass:"filter-btn",attrs:{"type":"primary"},on:{"click":_vm.handleFilter}},[_vm._v("\n          筛选\n        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"stats-section"},[_c('div',{staticClass:"stats-title"},[_vm._v("统计")]),_vm._v(" "),_c('div',{staticClass:"stats-grid"},[_c('div',{staticClass:"stat-item"},[_c('div',{staticClass:"stat-label"},[_vm._v("项目数量")]),_vm._v(" "),_c('div',{staticClass:"stat-value"},[_vm._v(_vm._s(_vm.statistics.projectCount))])]),_vm._v(" "),_c('div',{staticClass:"stat-item"},[_c('div',{staticClass:"stat-label"},[_vm._v("城市数量")]),_vm._v(" "),_c('div',{staticClass:"stat-value"},[_vm._v(_vm._s(_vm.statistics.cityCount))])]),_vm._v(" "),_c('div',{staticClass:"stat-item"},[_c('div',{staticClass:"stat-label"},[_vm._v("进度偏差正值城市数")]),_vm._v(" "),_c('div',{staticClass:"stat-value positive"},[_vm._v(_vm._s(_vm.statistics.positiveDeviationCount))])]),_vm._v(" "),_c('div',{staticClass:"stat-item"},[_c('div',{staticClass:"stat-label"},[_vm._v("进度偏差负值城市数")]),_vm._v(" "),_c('div',{staticClass:"stat-value negative"},[_vm._v(_vm._s(_vm.statistics.negativeDeviationCount))])])])])]),_vm._v(" "),_c('div',{staticClass:"table-section"},[_vm._m(1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"stripe":"","border":"","span-method":_vm.objectSpanMethod,"header-cell-style":{ background: '#f5f7fa', color: '#606266', fontWeight: 'bold' },"height":_vm.tableHeight},on:{"sort-change":_vm.handleSortChange}},[_c('el-table-column',{attrs:{"prop":"project","label":"项目","min-width":"100","fixed":"left","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"province","label":"省份","width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"city","label":"城市","width":"100","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"manager","label":"负责人","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"targetQuantity","label":"目标数量","width":"110","sortable":"custom","align":"center"}},[_c('template',{slot:"header"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"排序只在同项目内生效","placement":"top"}},[_c('span',[_vm._v("目标数量")])])],1)],2),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"yesterdayCompleted","label":"昨日完成","width":"110","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"currentCompleted","label":"当前完成","width":"110","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"growth","label":"增长","width":"100","sortable":"custom","align":"center"}},[_c('template',{slot:"header"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"排序只在同项目内生效","placement":"top"}},[_c('span',[_vm._v("增长")])])],1)],2),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"completionRate","label":"当前完成率","width":"130","sortable":"custom","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.completionRate)+"%\n        ")]}}])},[_c('template',{slot:"header"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"排序只在同项目内生效","placement":"top"}},[_c('span',[_vm._v("当前完成率")])])],1)],2),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"progressDeviation","label":"进度偏差值","width":"130","sortable":"custom","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"deviation-value",class:scope.row.progressDeviation >= 0 ? 'deviation-positive' : 'deviation-negative'},[_c('i',{class:scope.row.progressDeviation >= 0 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'}),_vm._v("\n            "+_vm._s(Math.abs(scope.row.progressDeviation))+"\n          ")])]}}])},[_c('template',{slot:"header"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"排序只在同项目内生效","placement":"top"}},[_c('span',[_vm._v("进度偏差值")])])],1)],2),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activeUsers","label":"活跃用户","min-width":"110","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"standbyUsers","label":"待机用户","min-width":"110","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"participatingUsers","label":"参与用户数","width":"120","align":"center"}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-center"},[_c('h1',{staticClass:"system-title"},[_vm._v("推广部项目进度系统")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-title"},[_vm._v("项目执行明细 "),_c('span',{staticStyle:{"font-size":"12px","color":"#999"}},[_vm._v("(目标数量，增长，当前完成率，进度偏差值数据的排序只在同项目内生效)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4119:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4120);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("77567d03", content, true, {});

/***/ }),

/***/ 4120:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"HomeIndex.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4121:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4122);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f27daca2", content, true, {});

/***/ }),

/***/ 4122:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".center[data-v-5fd405ee]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;background-color:#eff0f4;padding-right:60px}", "", {"version":3,"sources":["/workspace/src/views/home/pages/HomeIndex.vue"],"names":[],"mappings":"AACA,yBAAyB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,YAAY,yBAAyB,kBAAkB,CAC1Q","file":"HomeIndex.vue","sourcesContent":["\n.center[data-v-5fd405ee]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;background-color:#eff0f4;padding-right:60px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4123:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3d80a366", content, true, {});

/***/ }),

/***/ 4124:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"HomeIndex.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('img',{staticStyle:{"display":"block","width":"100%","height":"auto"},attrs:{"src":"/static/img/home-content.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/home-index.1816488259763dcf66d9.js